import { Event, EventType } from "./Event";

import type { IAddPersistentImpressionEvent } from "./types";

export class AddPersistentImpressionEvent extends Event {
  constructor({
    itemId,
    page,
    section,
    position,
    tracking,
    customEventProperties,
  }: IAddPersistentImpressionEvent) {
    super({
      event_type: EventType.persistent_impression,
      event_properties: {
        item_id: itemId,
        page,
        section,
        position,
        tracking,
      },
      custom_event_properties: customEventProperties,
    });
  }
}
